module.exports = __webpack_public_path__ + "static/Register-895d1a3dbdae120c1f65b7445779f568.png";